(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-collection-menu"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const currentURL = window.location.pathname;
  const links = document.querySelectorAll('.issy-collection-menu a');

  links.forEach(link => {
    const linkPath = new URL(link.href).pathname;
    if (currentURL === linkPath) {
      link.classList.add('active');
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
